import { Injectable } from '@angular/core';
import { ExportExecutableParams, StackingPlanExportTypes } from '../export.model';
import { ExportResolver } from './export-resolver.model';
import { PVExportExcelService } from './pv-export-excel';
import { PVExportPDFService } from './pv-export-pdf';
import { throwError } from 'rxjs';

@Injectable()
export class PVExportResolver implements ExportResolver<ExportExecutableParams, boolean> {
  #serviceByTypeMapping = {};

  constructor(
    private _excelExport: PVExportExcelService,
    private pdfExport: PVExportPDFService
  ) {
    this.#serviceByTypeMapping = {
      [StackingPlanExportTypes.PVExcel]: this._excelExport,
      [StackingPlanExportTypes.PVPDF]: this.pdfExport,
    };
  }

  resolve(params: ExportExecutableParams) {
    return (
      this.#serviceByTypeMapping[params.exportType]?.execute(params) ||
      throwError(() => 'No service found for the given export type')
    );
  }
}
